import Page from '../../components/templates/Page'
import Welcome from '../../components/pages/guest-experience/Welcome'
import Summary from '../../components/pages/guest-experience/Summary'
import Services from '../../components/pages/guest-experience/Services'
import Reviews from '../../components/pages/home/Reviews'
import Section from '../../components/elements/Section'
import Contact from '/components/pages/common/Contact'
import FAQs from '/components/pages/common/FAQs'
import Professionals from '/components/pages/common/Professionals'
import { useRef } from 'react'
import axios from '/components/configs/axios'
import cache from 'memory-cache'
import footerTranslation from '/components/general/Footer/footerTranslations'
import headerTranslation from '/components/general/Header/headerTranslation'
import guestExperienceTranslation from '/components/pages/guest-experience/guestExperienceTranslation'
import { useRouter } from 'next/router'
import contactTranslation from '/components/pages/common/Contact/contactTranslations'

export const getStaticProps = async ({ locale }) => {
  const pageData = await axios
    .get('info/guest')
    .then((res) => res.data[locale])
    .catch((err) => {
      console.error(err)
    })

  let headerDataTranslation = cache.get('headerTranslations')
  if (!headerDataTranslation) {
    headerDataTranslation = await headerTranslation()
    cache.put('headerTranslations', headerDataTranslation)
  }

  // caching for footer translations
  let footerDataTranslation = cache.get('footerTranslations')
  if (!footerDataTranslation) {
    footerDataTranslation = await footerTranslation()
    cache.put('footerTranslations', footerDataTranslation)
  }

  let pageTranslationData = cache.get('homepageTranslations')
  if (!pageTranslationData) {
    pageTranslationData = await guestExperienceTranslation()
  }

  let contactFormTranslationData = cache.get('contactFormTranslations')
  if (!contactFormTranslationData) {
    contactFormTranslationData = await contactTranslation()
  }

  return {
    props: {
      pageData: pageData,
      translations: pageTranslationData,
      headerTranslation: headerDataTranslation,
      footerTranslation: footerDataTranslation,
      contactTranslation: contactFormTranslationData
    },
    revalidate: 300
  }
}

const GuestExperience = ({
  pageData,
  headerTranslation,
  footerTranslation,
  contactTranslation,
  translations
}) => {
  const ref = useRef(null)
  const router = useRouter()

  return (
    <Page
      headerTranslation={headerTranslation}
      footerTranslation={footerTranslation}
      footer={false}
      meta={{
        title: translations.seo.title[router.locale],
        description: translations.seo.description[router.locale]
      }}
    >
      <Welcome
        title={translations.welcome.title[router.locale]}
        subtitle={translations.welcome.subtitle[router.locale]}
        button={translations.welcome.button[router.locale]}
        video={pageData.cloudflare_video}
      />

      <Summary
        label={translations.summary.label[router.locale]}
        title={translations.summary.title[router.locale]}
        description={translations.summary.description[router.locale]}
        statistics={pageData.statistics}
      />

      <Services services={pageData.service} />

      <Section variant={['white', 'center']}>
        <Reviews reviews={pageData.reviews} sectionRef={ref} />
      </Section>

      <Professionals
        staff={pageData?.staff}
        label={translations.professionals.label[router.locale]}
        title={translations.professionals.title[router.locale]}
      />

      <FAQs
        label={translations.faqs.label[router.locale]}
        title={translations.faqs.title[router.locale]}
        button={translations.faqs.button[router.locale]}
        faqs={pageData.faq}
      />

      <Contact
        translations={contactTranslation}
        sectionRef={ref}
        title={translations.contact.title[router.locale]}
        description={translations.contact.description[router.locale]}
        staff={pageData.person}
        buying={false}
        separator={false}
        variant={['white']}
      />
    </Page>
  )
}

export default GuestExperience
